const WalletIcon = ({ ...props }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 4C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V8C21 7.44772 20.5523 7 20 7H6C5.72386 7 5.5 6.77614 5.5 6.5C5.5 6.22386 5.72386 6 6 6H17C17.5523 6 18 5.55228 18 5C18 4.44772 17.5523 4 17 4H5ZM15 12.5C15 12.2239 15.2239 12 15.5 12H18.5C18.7761 12 19 12.2239 19 12.5V14.5C19 14.7761 18.7761 15 18.5 15H15.5C15.2239 15 15 14.7761 15 14.5V12.5Z"
			fill="currentColor"
		/>
	</svg>
)

export default WalletIcon
